/* =========================================================================
   Bundle Items builder
   - Renders N slots (N = custom.bundle_qty), each backed by bundle-icon.png.
   - Clicking a slot opens a popup listing custom.bundle_items child products.
   - Picking a child fills the slot. Every slot is required.
   - When all slots are filled, the "Add Bundle to Cart" button is enabled.
   - Each selection is written into the product form as a line item property
     (properties[Item N] = child title) so it shows on cart / checkout / order.
   The actual /cart/add.js request is handled by the theme's existing
   .__product-cart-button handler (custom.js), which serializes this form.
   ========================================================================= */
(function () {
  'use strict';

  if (window.customElements && !customElements.get('bundle-builder')) {
    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        this.qty = parseInt(this.dataset.bundleQty, 10) || 1;
        this.formId = this.dataset.formId;
        this.form = document.getElementById(this.formId);
        this.propsHost = this.querySelector('.bundle-properties');
        this.addBtn = this.querySelector('.bundle-add');
        this.countEl = this.querySelector('.bundle-builder__count');
        this.modal = this.querySelector('.bundle-modal');
        this.slotNameEl = this.querySelector('.bundle-modal__slot-name');
        this.slots = Array.prototype.slice.call(this.querySelectorAll('.bundle-slot'));
        this.choices = Array.prototype.slice.call(this.querySelectorAll('.bundle-choice'));
        this.activeSlot = null;
        // selections keyed by slot number -> { title }
        this.selections = {};

        this.bindEvents();
      }

      bindEvents() {
        var self = this;

        this.slots.forEach(function (slot) {
          slot.addEventListener('click', function () {
            self.openModal(slot);
          });
        });

        this.choices.forEach(function (choice) {
          if (choice.disabled) return;
          choice.addEventListener('click', function () {
            self.pick(choice);
          });
        });

        this.querySelectorAll('[data-bundle-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            self.closeModal();
          });
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.modal && !self.modal.hasAttribute('hidden')) {
            self.closeModal();
          }
        });
      }

      openModal(slot) {
        this.activeSlot = slot;
        var n = slot.getAttribute('data-slot');
        if (this.slotNameEl) this.slotNameEl.textContent = 'Item ' + n;
        if (this.modal) this.modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        if (this.modal) this.modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
        this.activeSlot = null;
      }

      pick(choice) {
        if (!this.activeSlot) return;
        var slot = this.activeSlot;
        var n = slot.getAttribute('data-slot');
        var title = choice.getAttribute('data-title') || '';
        var image = choice.getAttribute('data-image') || '';

        // update slot visuals
        slot.classList.add('is-filled');
        var thumb = slot.querySelector('.bundle-slot__thumb');
        if (thumb) {
          if (image) {
            thumb.setAttribute('src', image);
            thumb.setAttribute('alt', title);
            thumb.removeAttribute('hidden');
          }
        }
        var chosen = slot.querySelector('.bundle-slot__chosen');
        if (chosen) chosen.textContent = title;

        // record + write line item property
        this.selections[n] = { title: title };
        this.writeProperty(n, title);

        this.closeModal();
        this.refresh();
      }

      writeProperty(n, title) {
        if (!this.propsHost) return;
        var name = 'properties[Item ' + n + ']';
        var input = this.propsHost.querySelector('input[data-slot="' + n + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-slot', n);
          this.propsHost.appendChild(input);
        }
        input.name = name;
        input.value = title;
      }

      refresh() {
        var filled = Object.keys(this.selections).length;
        if (this.countEl) this.countEl.textContent = filled;

        var complete = filled >= this.qty;
        var available = !this.addBtn || this.addBtn.getAttribute('data-available') !== 'false';
        if (this.addBtn) {
          this.addBtn.disabled = !(complete && available);
        }
      }
    }

    customElements.define('bundle-builder', BundleBuilder);
  }
})();
